export const breakpoints = [576, 768, 992, 1200];
